export const gameData = [
    {
        name: "Apocalypse World",
        hypName: "apocalypse-world",
        imageUrl: "https://i.imgur.com/axsiHTi.png",
    },
    {
        name: "Burned Over",
        hypName: "burned-over",
        imageUrl: "https://i.imgur.com/t4RSNmg.png",
    },
    {
        name: "Dungeon World",
        hypName: "dungeon-world",
        imageUrl: "https://i.imgur.com/axsiHTi.png",
    },
    {
        name: "Masks",
        hypName: "masks",
        imageUrl: "https://i.imgur.com/ThMlFyE.png",
    },
    {
        name: "Monsterhearts 2",
        hypName: "monsterhearts-2",
        imageUrl: "https://i.imgur.com/T6tTf9N.jpg",
    },
    {
        name: "Monster of the Week",
        hypName: "monster-of-the-week",
        imageUrl: "https://i.imgur.com/a9Bi8zM.jpg",
    },
    {
        name: "The Sprawl",
        hypName: "the-sprawl",
        imageUrl: "https://i.imgur.com/qwbb6vQ.jpg",
    },
    {
        name: "The Veil",
        hypName: "the-veil",
        imageUrl: "https://i.imgur.com/ML1mEvp.jpg",
    },
    {
        name: "Uncharted Worlds",
        hypName: "uncharted-worlds",
        imageUrl: "https://i.imgur.com/MJB1dGn.png",
    },
    {
        name: "Urban Shadows",
        hypName: "urban-shadows",
        imageUrl: "https://i.imgur.com/Cmgo3Cf.jpg",
    },


]